(function () {
  var toggle = document.querySelector("[data-menu-toggle]");
  var nav = document.querySelector("[data-header-nav]");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      nav.classList.toggle("is-open");
    });
  }

  document.querySelectorAll("[data-tabs]").forEach(function (root) {
    var buttons = root.querySelectorAll("[data-tab]");
    var panels = root.querySelectorAll("[data-tab-panel]");
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-tab");
        buttons.forEach(function (b) { b.classList.toggle("is-active", b === btn); });
        panels.forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-tab-panel") === id); });
      });
    });
  });

  document.querySelectorAll("[data-gallery]").forEach(function (root) {
    var main = root.querySelector("[data-gallery-main]");
    root.querySelectorAll("[data-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll("[data-thumb]").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        if (main) main.src = btn.getAttribute("data-src");
      });
    });
  });

  document.querySelectorAll("[data-plans]").forEach(function (root) {
    root.querySelectorAll("[data-plan-select]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-plan-select");
        root.querySelectorAll("[data-plan]").forEach(function (plan) {
          var on = plan.getAttribute("data-plan") === id;
          plan.classList.toggle("is-on", on);
          var dot = plan.querySelector(".radio-dot, .hp-radio");
          if (dot) dot.classList.toggle("is-on", on);
        });
        var onceBtn = root.querySelector("[data-plan-select='once']");
        if (onceBtn && onceBtn.tagName === "BUTTON") {
          onceBtn.classList.toggle("is-on", id === "once");
        }
      });
    });
  });

  document.querySelectorAll("[data-label-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var card = btn.closest("[data-label-card]");
      if (!card) return;
      var off = card.querySelector("[data-off]");
      var on = card.querySelector("[data-on]");
      if (!off || !on) return;
      var showing = !on.hasAttribute("hidden");
      if (showing) {
        on.setAttribute("hidden", "");
        off.removeAttribute("hidden");
        btn.textContent = "View label ?";
      } else {
        off.setAttribute("hidden", "");
        on.removeAttribute("hidden");
        btn.textContent = "View product ?";
      }
    });
  });

  document.querySelectorAll("[data-scents]").forEach(function (root) {
    var slides = [
      root.querySelector("[data-scent-go='0'] img") && root.querySelector("[data-scent-go='0'] img").src,
      root.querySelector("[data-scent-go='1'] img") && root.querySelector("[data-scent-go='1'] img").src,
      root.querySelector("[data-scent-go='2'] img") && root.querySelector("[data-scent-go='2'] img").src,
      root.querySelector("[data-scent-go='3'] img") && root.querySelector("[data-scent-go='3'] img").src
    ];
    var main = root.querySelector("[data-scent-main]");
    var alts = ["Cedar", "Mint", "Yuzu", "Basil"];
    function show(index) {
      if (!main || !slides[index]) return;
      main.src = slides[index];
      main.alt = alts[index];
      root.querySelectorAll("[data-scent-go]").forEach(function (el) {
        el.classList.toggle("is-on", el.getAttribute("data-scent-go") === String(index));
      });
    }
    root.querySelectorAll("[data-scent-go]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        show(btn.getAttribute("data-scent-go"));
      });
    });
  });

  document.querySelectorAll("[data-hair-slider]").forEach(function (root) {
    var track = root.querySelector("[data-hair-track]");
    var prev = root.querySelector("[data-hair-prev]");
    var next = root.querySelector("[data-hair-next]");
    if (!track || !prev || !next) return;
    var animating = false;

    function cardStep() {
      var card = track.querySelector(".hair-card");
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function go(dir) {
      if (animating || !track.children.length) return;
      var step = cardStep();
      if (!step) return;
      animating = true;
      if (dir > 0) {
        track.style.transition = "transform .45s ease";
        track.style.transform = "translateX(" + (-step) + "px)";
        track.addEventListener("transitionend", function done(e) {
          if (e.target !== track) return;
          track.removeEventListener("transitionend", done);
          track.style.transition = "none";
          track.appendChild(track.firstElementChild);
          track.style.transform = "translateX(0)";
          animating = false;
        });
      } else {
        track.style.transition = "none";
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        track.style.transform = "translateX(" + (-step) + "px)";
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.style.transition = "transform .45s ease";
            track.style.transform = "translateX(0)";
            track.addEventListener("transitionend", function done(e) {
              if (e.target !== track) return;
              track.removeEventListener("transitionend", done);
              animating = false;
            });
          });
        });
      }
    }

    prev.addEventListener("click", function () { go(-1); });
    next.addEventListener("click", function () { go(1); });
  });

  document.querySelectorAll("[data-result-slider]").forEach(function (root) {
    var track = root.querySelector("[data-result-track]");
    var prev = root.querySelector("[data-result-prev]");
    var next = root.querySelector("[data-result-next]");
    if (!track || !prev || !next) return;
    var animating = false;

    function cardStep() {
      var card = track.querySelector(".result-card");
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function go(dir) {
      if (animating || !track.children.length) return;
      var step = cardStep();
      if (!step) return;
      animating = true;
      if (dir > 0) {
        track.style.transition = "transform .45s ease";
        track.style.transform = "translateX(" + (-step) + "px)";
        track.addEventListener("transitionend", function done(e) {
          if (e.target !== track) return;
          track.removeEventListener("transitionend", done);
          track.style.transition = "none";
          track.appendChild(track.firstElementChild);
          track.style.transform = "translateX(0)";
          animating = false;
        });
      } else {
        track.style.transition = "none";
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        track.style.transform = "translateX(" + (-step) + "px)";
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.style.transition = "transform .45s ease";
            track.style.transform = "translateX(0)";
            track.addEventListener("transitionend", function done(e) {
              if (e.target !== track) return;
              track.removeEventListener("transitionend", done);
              animating = false;
            });
          });
        });
      }
    }

    prev.addEventListener("click", function () { go(-1); });
    next.addEventListener("click", function () { go(1); });
  });

  document.querySelectorAll("[data-reviews]").forEach(function (root) {
    var extra = root.querySelectorAll("[data-review-extra]");
    var more = root.querySelector("[data-reviews-more]");
    if (more) {
      more.addEventListener("click", function () {
        extra.forEach(function (el) { el.removeAttribute("hidden"); });
        more.setAttribute("hidden", "");
      });
    }
    root.querySelectorAll("[data-read-more]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var body = btn.previousElementSibling;
        if (body) body.classList.add("is-open");
        btn.setAttribute("hidden", "");
      });
    });
  });

  document.querySelectorAll("[data-cart-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("[data-qty-input]");
    var key = wrap.getAttribute("data-key");
    if (!input || !key) return;

    function setQty(next) {
      var qty = parseInt(next, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }

    wrap.querySelector("[data-qty-minus]").addEventListener("click", function () {
      setQty(Math.max(0, parseInt(input.value, 10) - 1));
    });
    wrap.querySelector("[data-qty-plus]").addEventListener("click", function () {
      setQty(parseInt(input.value, 10) + 1);
    });
    input.addEventListener("change", function () {
      setQty(input.value);
    });
  });

  document.querySelectorAll("form[action='/cart/add']").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: data })
        .then(function () { window.location.href = "/cart"; })
        .catch(function () { form.submit(); });
    });
  });
})();
